import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as fromInvitesActions from '../actions/invite.actions';
import { catchError, map, switchMap } from 'rxjs/operators';
import { EMPTY, of } from 'rxjs';
import { NotificationService, UsersService } from '@fc-core';
import { MatDialog } from '@angular/material/dialog';
import { getErrorMessage } from '@fc-core/services/notification.utils';

@Injectable()
export class InviteEffects {
  constructor(
    private actions$: Actions,
    private usersService: UsersService,
    private dialog: MatDialog,
    private notifications: NotificationService,
  ) {}

  loadInvites$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromInvitesActions.loadInvites),
      switchMap(() =>
        this.usersService.loadInvites().pipe(
          map(({ list, count }) => {
            return fromInvitesActions.loadInvitesSuccess({
              invites: list,
              count,
            });
          }),
          catchError((error) => of(fromInvitesActions.invitesError({ error }))),
        ),
      ),
    ),
  );

  resendInvite$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromInvitesActions.resendInvite),
      switchMap(({ inviteId, employee }) =>
        this.usersService.resendInvitation(inviteId, employee).pipe(
          map(() => {
            this.notifications.showSuccess('Invite successfully resended');
            this.dialog.closeAll();
            return fromInvitesActions.resendInviteSuccess();
          }),
          catchError((error) => of(fromInvitesActions.invitesError({ error }))),
        ),
      ),
    ),
  );

  invitesError$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fromInvitesActions.invitesError),
        switchMap((error) => {
          this.notifications.showError(getErrorMessage(error?.error));
          return EMPTY;
        }),
      ),
    { dispatch: false },
  );
}
